import React from 'react';
import './footer.scss';


export default function Footer() {
  return (
    <>
      <footer><a href="https://github.com/meanJerkTime" target="_blank" rel="noreferrer">&copy; 2021 Mean Jerk Time</a></footer>
    </>
  );
}